/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../Redux/Store/hooks';
import { CatalogObjectControllerData } from '../../../Data/CatalogObjectControllerData';
import { Customization } from '../../../../common/libraries/modelViewer/Data/Customization';
import { CustomizationConfiguration } from '../../../../common/libraries/modelViewer/Data/CustomizationConfiguration';
import { CustomizationValue } from '../../../Data/CustomizationValue';
import { POSCatalogModelData } from '../../../../common/libraries/modelViewer/Data/POSCatalogData';
import { Currencies } from '../../../Util/currencies';
import { ModelGroupInfo } from '../../../../common/libraries/fileFormats/sltx/modelGroupInfo';
import { ItemMeasuresInfo } from '../../../../common/libraries/fileFormats/ItemMeasuresInfo';

import './OrderDetailsComponent.css';
import { CatalogFileCustomAttributesDefinition, PriceData, PriceDataHelpers } from '../../../../common/libraries/fileFormats/catalog/catalog';

import { MeasuresItemData } from '../../../../common/libraries/fileFormats/measuresItemData';
import { CustomAttributeType } from '../../../../common/libraries/customAttributes/customAttributeType';

import { CustomAttributeData } from '../../../../common/libraries/customAttributes/customAttributes';
import { CustomAttributeValue } from '../../../../common/libraries/customAttributes/customAttributeValue';
import { ComponentCustomOptionGroupExtension } from '../../../../common/libraries/react/customAttributes/controls/customOptionGroupExtension';
import { CustomAttributeClassPrefix } from '../../../../common/libraries/customAttributes/customAttributesClassPrefix';
import { SLTXFormatRootFileGroup } from '../../../../common/libraries/fileFormats/sltx/sltx';

import { SLTXFile } from '../../../../common/libraries/fileFormats/sltx/sltxFile';
import { SLTXTranslations } from '../../../../common/libraries/fileFormats/sltx/sltxTranslations';
import { CartItemHelper } from '../../../Data/CartItem';
import { ConditionEvaluator } from '../../../../common/libraries/modelConfiguration/rules/rulesConditionEvaluator';
import { ModelConfigurationLinearCustomAttributes } from '../../../../common/libraries/react/modelConfiguration/modelConfigurationLinearCustomAttributes';

type OrderDetailsComponentParameters = {
  orderDetailsInDisplayHandler: (displayOrderDetails: boolean) => void,
  addItemToCartHandler: (itemQuantity: number, itemDetails: Array<ItemMeasuresInfo>, itemAttributes: CustomAttributeValue[]) => void,
  priceData: PriceData[] | undefined,
  objectMeasures: MeasuresItemData[] | undefined,
  customLineAttributes: CatalogFileCustomAttributesDefinition | undefined,
  objectInfo: CatalogObjectControllerData,
  objectCustomizations: CustomizationConfiguration | undefined,
  languageSelected: string,
  sltxFile: SLTXFile | undefined,
};

export function OrderDetailsComponent({
  orderDetailsInDisplayHandler,
  addItemToCartHandler,
  priceData,
  objectMeasures,
  customLineAttributes,
  objectInfo,
  objectCustomizations,
  languageSelected,
  sltxFile,
}: OrderDetailsComponentParameters) {

  const [itemQuantity, setItemQuantity] = React.useState<number>(1);
  const [isAddingItemToCart, setIsAddingItemToCard] = React.useState<boolean>(false);
  const [selectedSizes, setSelectedSizes] = React.useState<number[]>([0, 0, 0]);
  const [customOrderLineAttributesValues, setCustomOrderLineAttributesValues] = React.useState<Array<CustomAttributeValue>>(new Array<CustomAttributeValue>());
  const [selectedMeasures, setSelectedMeasures] = React.useState<Array<ItemMeasuresInfo>>(new Array<ItemMeasuresInfo>());
  const [globalShowPrices, setGlobalShowPrices] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;
    const computedStyle = getComputedStyle(root);

    const showPricesValue = computedStyle.getPropertyValue('--show-prices').trim();
    setGlobalShowPrices(showPricesValue === 'true');
  }, []);

  const isOptioValueActive = (
    optioValue: string,
  ) : boolean => {
    return (optioValue !== 'No'
      && optioValue !== 'None'
      && optioValue !== 'false');
  };

  const lang: string = languageSelected;

  const getTranslatedComponentName = (component: SLTXFormatRootFileGroup) => {
    if (sltxFile) return SLTXTranslations.getTranslatedComponentName(component.id, sltxFile, lang);
    return component.name;
  };

  const getSelectedOptionForComponent = (component: SLTXFormatRootFileGroup, translate: boolean) => {
    const selectedVariantComponent = objectInfo.getVariantComposition().find(
      (v) => v.groupID === component.id,
    )!;

    if (sltxFile) return SLTXTranslations.getSelectedOptionTranslation(component.id, selectedVariantComponent.optionID, sltxFile, translate, lang);
    return '<undefined-01>';
  };

  const resetItemQuantity = () => {
    setItemQuantity(1);
  };

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const translations = useAppSelector((state) => {
    return state.TextsReducer.translation;
  })!;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const selectedLanguage = useAppSelector((state) => {
    return state.TextsReducer.language;
  })!;

  // From the store, get the cart
  const cartItems = useAppSelector((state) => {
    return state.CartReducer.cartItems;
  });

  // ----------------------------------------------------------------------------------------------
  // Eval attribute enabling /show/no show condition
  // ----------------------------------------------------------------------------------------------
  const checkAttrCondition = (
    condition: string | undefined,
  ): boolean => {
    if (!condition || !condition.trim()) return true;

    // Backward-compatible operator due to the
    // old style !== and ===  use in attrs conditions
    const normalizedCondition = condition
      .replace(/!==/g, '!=')
      .replace(/===/g, '==');

    const varValues: { attributeName: string; attributeValue: string }[] = [];

    varValues.push({ attributeName: 'item.name', attributeValue: `${objectInfo.catalogModelData.getName()}` });

    const custAttrsMap = customOrderLineAttributesValues.map((att) => ({
      attributeName: `${att.attributeKey}`,
      attributeValue: `${att.attributeValue}`,
    }));
    varValues.push(...custAttrsMap);

    const optionGrooupsMap = objectInfo.catalogModelData.getGroups().map((opt) => ({
      attributeName: `${decodeURI(opt.name)}`,
      attributeValue: `${getSelectedOptionForComponent(opt, false)}`,
    }));
    varValues.push(...optionGrooupsMap);

    const bResult = ConditionEvaluator.evaluateAttrCondition(normalizedCondition, varValues);

    return bResult;
  };

  // ----------------------------------------------------------------------------------------------
  // Can Checkout controlling the enabling of the "Add 2 Cart" button
  // ----------------------------------------------------------------------------------------------
  const [canCheckout, setCanCheckout] = useState(true);

  // ----------------------------------------------------------------------------------------------
  // Max number/quantity of Cart Items var that will affect also teh can checkout
  // ----------------------------------------------------------------------------------------------
  const [globalMacxCartItems, setMaxCartItems] = useState<number>(1);
  const numItemsInCart = cartItems.reduce(
    (result, item) => { return result + CartItemHelper.GetQuantity(item); },
    0,
  );

  // ----------------------------------------------------------------------------------------------
  // Read css's  --max-cart-item and set the MaxCartItem state
  // ----------------------------------------------------------------------------------------------
  useEffect(() => {
    const root = document.documentElement;
    const computedStyle = getComputedStyle(root);

    const maxCartItemsStr = computedStyle.getPropertyValue('--max-cart-items').trim();
    const maxCartItemsNum = parseInt(maxCartItemsStr, 10);

    // eslint-disable-next-line no-restricted-globals
    setMaxCartItems(isNaN(maxCartItemsNum) ? -1 : maxCartItemsNum);
  }, []);

  // ----------------------------------------------------------------------------------------
  // Check if all mandatory attrs were set and call setCanCheckOut accrodingly
  // -----------------------------------------------------------------------------------------
  useEffect(() => {
    let isCheckoutActive = true;
    customLineAttributes?.attributes.forEach((att) => {
      if (att.isMandatory) {
        const savedAttribute = customOrderLineAttributesValues.find((satt) => satt.attributeKey === att.key);
        // eslint-disable-next-line max-len
        if (savedAttribute?.attributeEnabled
          && (savedAttribute?.attributeKey === undefined
            || savedAttribute?.attributeValue === undefined
            || savedAttribute?.attributeValue === '')) {
          isCheckoutActive = false;
        }
      }
    });
    setCanCheckout(isCheckoutActive && ((globalMacxCartItems < 0) || (numItemsInCart < globalMacxCartItems)));
  }, [customOrderLineAttributesValues, numItemsInCart]);

  const getComponentPrice = (componentId: number): number => {

    // ----------------------------------------------------------------------------------------
    // We need to go to the selected options, grab the ID, and then grab the name
    // ----------------------------------------------------------------------------------------
    // eslint-disable-next-line max-len
    const selectedVariantComponent = objectInfo.getVariantComposition().find(
      (v) => v.groupID === componentId,
    )!;

    const selectedVariantComponentOption = selectedVariantComponent.optionID;
    // Now, grab the option name
    const objectComponent = objectInfo.catalogModelData.getGroups().find(
      (g) => g.id === componentId,
    )!;

    const groupOptions = ModelGroupInfo.getGroupAllOptions(objectComponent);

    const objectComponentOption = groupOptions.find(
      (o) => o.id === selectedVariantComponentOption,
    );

    let selectedFolder;
    for (let i = 0; i < objectComponent.optionsFolders.length; i++) {
      for (let n = 0; n < objectComponent.optionsFolders[i].options.length; n++) {
        if (objectComponent.optionsFolders[i].options[n].id === selectedVariantComponentOption) {
          selectedFolder = objectComponent.optionsFolders[i];
          break;
        }
      }

      if (selectedFolder) { break; }
    }
    const model = objectInfo.catalogModelData.getName();
    const priceCode = `${selectedFolder?.name}+${objectComponentOption?.name}`;
    const priceInfo = priceData ? PriceDataHelpers.getOptionPrice(priceData, model, objectComponent.name, priceCode) : undefined;
    const price = priceInfo || 0;

    return price;
  };

  const getComponentsTotalPrice = (): number => {
    let optionsTotalPrice: number = 0;
    objectInfo.catalogModelData.getGroups().forEach((component) => {
      const selectedVariantComponent = objectInfo.getVariantComposition().find(
        (v) => v.groupID === component.id,
      )!;

      const selectedVariantComponentOption = selectedVariantComponent.optionID;
      // Now, grab the option name
      const objectComponent = objectInfo.catalogModelData.getGroups().find(
        (g) => g.id === component.id,
      )!;

      const groupOptions = ModelGroupInfo.getGroupAllOptions(objectComponent);

      const objectComponentOption = groupOptions.find(
        (o) => o.id === selectedVariantComponentOption,
      );

      let selectedFolder;
      for (let i = 0; i < objectComponent.optionsFolders.length; i++) {
        for (let n = 0; n < objectComponent.optionsFolders[i].options.length; n++) {
          if (objectComponent.optionsFolders[i].options[n].id === selectedVariantComponentOption) {
            selectedFolder = objectComponent.optionsFolders[i];
            break;
          }
        }
        if (selectedFolder) { break; }
      }

      const model = objectInfo.catalogModelData.getName();
      const priceCode = `${selectedFolder?.name}+${objectComponentOption?.name}`;
      const priceInfo = priceData ? PriceDataHelpers.getOptionPrice(priceData, model, objectComponent.name, priceCode) : undefined;
      const price = priceInfo || 0;

      optionsTotalPrice += priceInfo !== undefined ? parseFloat(price.toString()) : parseFloat('0');
    });

    return optionsTotalPrice;
  };

  const getVariantDescription = (catalogObjectControllerData: CatalogObjectControllerData) => {

    const text = POSCatalogModelData.GetVariantDescription(
      catalogObjectControllerData.getVariantComposition(),
      catalogObjectControllerData.catalogModelData.getVariants(),
    );

    if (text === '') {
      return strings.CUSTOMIZED_VARIANT;
    }
    return text;
  };

  const getCustomizationName = (customizationID: string) => {

    if (objectCustomizations === undefined) {
      return '';
    }

    const arrCustomizations = objectCustomizations.customizations;

    const customization = arrCustomizations.find(
      (c) => Customization.getID(c) === customizationID,
    );

    if (customization) {
      return Customization.getName(customization);
    }
    return '';

  };

  const getAttributeQuantity = function (key: string | undefined, requestedValue: string) : number | undefined {
    if (key === undefined) {
      return -1;
    }
    const attribute = customLineAttributes?.attributes.find((att) => att.key === key);
    const oldAttributeValue = customOrderLineAttributesValues.find((attV) => attV.attributeKey === key);
    return CustomAttributeData.getAttributeQuantity(attribute, oldAttributeValue, requestedValue);
  };

  const fillAttributeQuantity = function (value: number, key: string | undefined) {

    if (key === undefined) {
      return;
    }

    const attribute = customLineAttributes?.attributes.find((att) => att.key === key);
    if (attribute === undefined) {
      return;
    }

    if (attribute.hasQuantity) {
      if (!Number(value)) return;
      if (+value < 0) return;
    }

    const quantity2set = attribute.hasQuantity ? value : -1;

    if (attribute.key && attribute.name) {
      const oldAttribute = customOrderLineAttributesValues.find((att) => att.attributeKey === attribute.key);
      const newAttributes = customOrderLineAttributesValues.filter((att) => att.attributeKey !== attribute.key);
      newAttributes.push({
        attributeKey: attribute.key,
        attributeName: attribute.name,
        attributeValue: oldAttribute !== undefined ? oldAttribute.attributeValue : '',
        attributeTranslatedValue: oldAttribute !== undefined ? oldAttribute.attributeTranslatedValue : '',
        attributeQuantity: quantity2set,
        attributeBasePrice: attribute.basePrice,
        attributeEnabled: checkAttrCondition(attribute.condition),
      });
      setCustomOrderLineAttributesValues(newAttributes);
    }
  };

  const renderCustomizations = () => {

    const customizations = objectInfo.customizationData;

    if (!customizations || customizations.length === 0) {
      return (<div className="empty" />);
    }

    return (
      <>
        <p className="checkoutGroupName">{strings.CUSTOMIZATIONS}</p>
        <table className="partsTable">
          <tbody>
            {customizations.map((customization) => {
              return (
                <tr
                  key={`${CustomizationValue.getPartIdentifier(
                    customization,
                  )} ${CustomizationValue.getCustomizationID(customization)}`}
                >
                  <td key="a">
                    <p className="groupName">
                      {CustomizationValue.getPartIdentifier(customization)}
                    </p>
                  </td>
                  <td key="b">
                    <p className="optionName">
                      {getCustomizationName(
                        CustomizationValue.getCustomizationID(customization),
                      )}
                    </p>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  };

  const renderQuantityAndPrice = (groupName: string, optionName: string, componentId: number) : JSX.Element => {

    const componentPrice : number = getComponentPrice(componentId);
    const hideExtraCustomAttribute : boolean = !isOptioValueActive(optionName);

    const extraCustomAttr = customLineAttributes?.attributes.find((attr) => {
      return CustomAttributeData.isExtenderOf(attr, groupName);
    });

    if (!extraCustomAttr
      || !extraCustomAttr.hasQuantity || extraCustomAttr.type !== CustomAttributeType.Text || hideExtraCustomAttribute) {
      if (extraCustomAttr) fillAttributeQuantity(0, extraCustomAttr.key);
      return (
        <td>
          {(componentPrice > 0 && globalShowPrices) ? (
            <span className="optionPrice">
              {Currencies.formatPrice(getComponentPrice(componentId), objectInfo.catalogModelData.getPriceCurrency())}
            </span>
          ) : (
            <span />
          )}
        </td>
      );
    }
    const quantityToBe = getAttributeQuantity(extraCustomAttr.key, 'true');

    return (
      <ComponentCustomOptionGroupExtension
        attribute={extraCustomAttr}
        value="true"
        quantity={quantityToBe}
        onQuantityChanged={(value: number) => { fillAttributeQuantity(value, extraCustomAttr.key); }}
        editable={true}
        priceCurrencySymbol="€"
        priceData={priceData}
      />
    );

  };

  let totalItemCustomAttrPrice = 0.0;
  let totalItemExtrasCustomAttrPrice = 0.0;
  if (customLineAttributes !== undefined) {
    totalItemCustomAttrPrice = CustomAttributeData.calculateAttributesTotalPrice(customLineAttributes.attributes, customOrderLineAttributesValues, CustomAttributeClassPrefix.Extra, undefined, priceData);
    totalItemExtrasCustomAttrPrice = CustomAttributeData.calculateAttributesTotalPrice(customLineAttributes.attributes, customOrderLineAttributesValues, undefined, CustomAttributeClassPrefix.Extra, priceData);
  }
  let priceString = `${itemQuantity} * ${Currencies.formatPrice(objectInfo.catalogModelData.getPrice(priceData), objectInfo.catalogModelData.getPriceCurrency())}`;
  if (getComponentsTotalPrice() > 0) {
    priceString += ` + ${itemQuantity} x ${Currencies.formatPrice(getComponentsTotalPrice(), objectInfo.catalogModelData.getPriceCurrency())}`;
  }
  if (totalItemCustomAttrPrice > 0) {
    priceString += ` + ${itemQuantity} x ${Currencies.formatPrice(totalItemCustomAttrPrice, objectInfo.catalogModelData.getPriceCurrency())}`;
  }
  if (totalItemExtrasCustomAttrPrice > 0) {
    priceString += ` + ${Currencies.formatPrice(totalItemExtrasCustomAttrPrice, objectInfo.catalogModelData.getPriceCurrency())}`;
  }
  priceString += ` = ${Currencies.formatPrice(totalItemExtrasCustomAttrPrice + itemQuantity * (getComponentsTotalPrice() + objectInfo.catalogModelData.getPrice(priceData) + totalItemCustomAttrPrice), objectInfo.catalogModelData.getPriceCurrency())}`;

  const customItemAttributes = [...sltxFile?.getRootFileContents()?.customAttributes || []];
  return (
    <div className="order-details-holder">
      <div className="order-details border border-secondary rounded" style={{ width: '80%' }}>
        {/* Header section */}
        <div className="areaHeader">
          <div
            className="col-11"
            style={{ flexGrow: '1' }}
          >
            <h2 style={{ margin: '0', paddingBlock: '0.5rem', paddingInline: '1.2rem' }}>{strings.ADD_TO_CART_LABEL}</h2>
          </div>
          <div
            // className="col-1"
            style={{
              cursor: 'pointer', textAlign: 'center', flexGrow: '0', minWidth: '3rem',
            }}
            onClick={() => orderDetailsInDisplayHandler(false)}
          >
            <button
              type="button"
              className="btn btn-outline-secondary"
              aria-label="Close"
              style={{ float: 'none' }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        {/* Middle section */}
        <div className="order-details-option-div border-top border-bottom areaMiddle">
          {/* Object Name */}
          <div className="container">
            <div className="row align-items-start justify-content-between">
              <div className="objectName">
                {objectInfo.catalogModelData.getName()}
              </div>
            </div>
          </div>
          {objectInfo.catalogModelData.getGroups().length !== 0 && (
            <>
              {/* Variant */}
              <p className="variantName">{getVariantDescription(objectInfo)}</p>

              {/* Object Parts */}
              <p className="checkoutGroupName">{strings.PARTS}</p>

              <div className="order-details-group-contents">
                <table className="partsTable">
                  <tbody>
                    {objectInfo.catalogModelData.getGroups().map(
                      (component) => {
                        const groupName = getTranslatedComponentName(component); // decodeURI(component.name);
                        const optionName = getSelectedOptionForComponent(component, true);
                        if (!SLTXTranslations.IsGroupNameVisible(groupName)) {
                          return <tr key={`a-${component.id}`} className="empty" />;
                        }
                        return (
                          <tr key={`b-${component.id}`}>
                            <td>
                              <p className="groupName">
                                {`${groupName}`}
                              </p>
                            </td>
                            <td>
                              <p className="optionName">
                                {`${optionName}`}
                              </p>
                            </td>
                            { renderQuantityAndPrice(decodeURI(component.name), getSelectedOptionForComponent(component, false), component.id)}
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </div>
              <div
                className="row"
                style={
                  {
                    borderTop: '1px solid #444444',
                    margin: '0 0 20px 0',
                  }
                }
              />
              { /* Add Item's customAttibutes ------------------------------------------------------------------------------ */ }
              <div className="order-details-group-contents">
                <table className="partsTable">
                  <tbody>
                    {customItemAttributes.sort((a, b) => (a.priority - b.priority) || (a.name?.localeCompare(b.name || '') || 0))?.map((attrDef) => {
                      const attribute = objectInfo.customAttributesValues.find((e) => e.attributeKey === attrDef.key);
                      if (attribute === undefined || !attribute.attributeEnabled) {
                        return (
                          <tr key={`undef-${attrDef.key}`} className="empty" />
                        );
                      }
                      let priceCurrency = objectInfo.catalogModelData.getPriceCurrency();
                      if (!priceCurrency) {
                        priceCurrency = 0;
                      }
                      const attributePrice = CustomAttributeData.getAttributePrice(attribute, priceData);
                      const effectiveQuant = attribute.attributeQuantity < 0 && attributePrice > 0 ? 1 : attribute.attributeQuantity;
                      const effectiveTotalPrice = effectiveQuant * attributePrice;
                      const totalPrice = `${Currencies.formatPrice(effectiveTotalPrice, priceCurrency)}`;
                      let priceStr = effectiveQuant > 0 ? `${effectiveQuant} x ` : '';
                      priceStr += attributePrice > 0 && effectiveQuant > 0 ? `${attributePrice}` : '';
                      priceStr += effectiveTotalPrice > 0 ? ` = ${totalPrice}` : '';

                      let attrValue = attribute.attributeTranslatedValue ? attribute.attributeTranslatedValue : attribute.attributeValue;
                      if (attrDef.type === 'Boolean' || attribute.attributeValue === 'false') {
                        attrValue = attribute.attributeValue === 'true' ? strings.BOOLEAN_ATTRIBUTE_YES : strings.BOOLEAN_ATTRIBUTE_NO;
                      }
                      return (
                        <tr key={attribute.attributeName}>
                          <td>
                            <p className="groupName">
                              {attrDef.type === CustomAttributeType.Separator ? `${attribute.attributeName}` : ` - ${attribute.attributeName}`}
                            </p>
                          </td>
                          <td>
                            <p className="optionName">
                              {`${attrValue}`}
                            </p>
                          </td>
                          <td>
                            { globalShowPrices
                              ? (
                                <p className="orderOptionName">{priceStr}</p>
                              ) : (
                                <p className="orderOptionName">
                                  {effectiveQuant > 1 ? `x ${effectiveQuant}` : ''}
                                  {' '}
                                </p>
                              )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              { /* End of Add Item's customAttibutes ------------------------------------------------------------------------------ */ }
              <div
                className="row"
                style={
                  {
                    borderTop: '1px solid #444444',
                    margin: '0 0 20px 0',
                  }
                }
              />

              { sltxFile && (
              <ModelConfigurationLinearCustomAttributes
                className=""
                sltxFile={sltxFile}
                selectedOptions={objectInfo.getVariantComposition()}
                customAttributes={customLineAttributes?.attributes || []}
                customAttributesValues={customOrderLineAttributesValues}
                priceData={priceData}
                languageSelected={lang}
                changeCustomAttributesHandler={setCustomOrderLineAttributesValues}
                bCheckForExtras={true}
              />
              )}
              {/* Measures */}
              {objectMeasures && objectMeasures.length > 0
                && (
                  <>
                    <p className="checkoutGroupName">{strings.MEASURES}</p>
                    {objectMeasures.map((measures) => {
                      return (
                        <>
                          <p className="checkoutSubGroupName"><b>{measures.FirstDimensionName}</b></p>
                          <div className="container">
                            <div className="row justify-content-sm-left">
                              {measures.FirstDimension.map((firstDim, index) => {
                                if (measures.Constraints.find((c) => c.FirstDimensionSelection === firstDim)) {
                                  const className = selectedSizes[0] === index ? 'btn-secondary' : 'btn-outline-secondary';

                                  return (
                                    <div className="col-sm-1">
                                      <button
                                        className={`btn ${className}`}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`customAttribute-1-${index}`}
                                        type="button"
                                        style={{ marginBottom: '5px' }}
                                        onClick={() => {
                                          if (selectedMeasures.length > 0) {
                                            selectedMeasures[0].measureType = measures.FirstDimensionName;
                                            selectedMeasures[0].measureValue = firstDim;
                                          } else {
                                            const measuresInfo = new ItemMeasuresInfo();
                                            measuresInfo.measureType = measures.FirstDimensionName;
                                            measuresInfo.measureValue = firstDim;
                                            selectedMeasures.push(measuresInfo);
                                          }

                                          setSelectedMeasures([...selectedMeasures]);

                                          const buttonsSelected = [...selectedSizes];
                                          buttonsSelected[0] = index;
                                          setSelectedSizes(buttonsSelected);
                                        }}
                                      >
                                        {firstDim}
                                      </button>
                                    </div>
                                  );
                                }

                                return null;
                              })}
                            </div>
                          </div>
                          {selectedMeasures.length > 0 && (
                            <>
                              <p className="checkoutSubGroupName"><b>{measures.SecondDimensionName}</b></p>
                              <div className="container">
                                <div className="row justify-content-sm-left">
                                  {measures.Constraints.filter((c) => c.FirstDimensionSelection === selectedMeasures[0].measureValue).map((constraint, index) => {
                                    const className = selectedSizes[1] === index ? 'btn-secondary' : 'btn-outline-secondary';

                                    return (
                                      <div className="col-sm-1">
                                        <button
                                          className={`btn ${className}`}
                                          // eslint-disable-next-line react/no-array-index-key
                                          key={`customAttribute-2-${index}`}
                                          type="button"
                                          style={{ marginBottom: '5px' }}
                                          onClick={() => {
                                            if (selectedMeasures.length > 1) {
                                              selectedMeasures[1].measureType = measures.SecondDimensionName;
                                              selectedMeasures[1].measureValue = constraint.SecondDimensionSelection;
                                            } else {
                                              const measuresInfo = new ItemMeasuresInfo();
                                              measuresInfo.measureType = measures.SecondDimensionName;
                                              measuresInfo.measureValue = constraint.SecondDimensionSelection;
                                              selectedMeasures.push(measuresInfo);
                                            }

                                            setSelectedMeasures([...selectedMeasures]);

                                            const buttonsSelected = [...selectedSizes];
                                            buttonsSelected[1] = index;
                                            setSelectedSizes(buttonsSelected);
                                          }}
                                        >
                                          {constraint.SecondDimensionSelection}
                                        </button>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </>
                          )}
                          {selectedMeasures.length > 1 && (
                            <>
                              <p className="checkoutSubGroupName"><b>{measures.ThirdDimensionName}</b></p>
                              <div className="container">
                                <div className="row justify-content-sm-left">
                                  {measures.Constraints.filter((c) => c.FirstDimensionSelection === selectedMeasures[0].measureValue && c.SecondDimensionSelection === selectedMeasures[1].measureValue).map((constraint) => {
                                    const values = constraint.Value.split('-', 2);
                                    const minVal: number = +values[0];
                                    const maxVal: number = +values[1];
                                    const buttonValues: Array<number> = new Array<number>();
                                    for (let i = minVal; i < maxVal + 1; i++) {
                                      buttonValues.push(i);
                                    }
                                    return buttonValues.map((number, index) => {
                                      const className = selectedSizes[2] === index ? 'btn-secondary' : 'btn-outline-secondary';
                                      return (
                                        <div className="col-sm-1">
                                          <button
                                            className={`btn ${className}`}
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={`customAttribute-3-${index}`}
                                            type="button"
                                            style={{ marginBottom: '5px' }}
                                            onClick={() => {
                                              if (selectedMeasures.length > 2) {
                                                selectedMeasures[2].measureType = measures.ThirdDimensionName;
                                                selectedMeasures[2].measureValue = `${number}`;
                                              } else {
                                                const measuresInfo = new ItemMeasuresInfo();
                                                measuresInfo.measureType = measures.ThirdDimensionName;
                                                measuresInfo.measureValue = `${number}`;
                                                selectedMeasures.push(measuresInfo);
                                              }

                                              setSelectedMeasures([...selectedMeasures]);

                                              const buttonsSelected = [...selectedSizes];
                                              buttonsSelected[2] = index;
                                              setSelectedSizes(buttonsSelected);
                                            }}
                                          >
                                            {number}
                                          </button>
                                        </div>
                                      );
                                    });
                                  })}
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                  </>
                )}

              {/* Quantity */}
              <p className="checkoutGroupName">{strings.QUANTITY}</p>
              <div className="order-details-group-contents">
                <input
                  className="item-quantity-input"
                  type="number"
                  value={itemQuantity}
                  onChange={(event) => setItemQuantity(
                    // Math.max is to avoid having a quantity that's negative or zero
                    Math.max(1, Number.parseInt(event.target.value, 10)),
                  )}
                />
              </div>
            </>
          )}
          {renderCustomizations()}
        </div>
        {/* Footer section */}
        <div className="areaFooter">
          <div style={{ flexGrow: 1 }}>
            {globalShowPrices
              ? (
                <div style={{ fontSize: '18pt', textAlign: 'left' }}>
                  {`${priceString}`}
                </div>
              ) : (
                <div />
              )}
          </div>
          {!isAddingItemToCart
            ? (
              <button
                type="button"
                className="btn btn-secondary rounded"
                style={{
                  width: 'min(250px, 50%)',
                  height: '50px',
                  color: 'white',
                }}
                onClick={() => {
                  addItemToCartHandler(itemQuantity, selectedMeasures, customOrderLineAttributesValues);
                  setIsAddingItemToCard(true);
                  orderDetailsInDisplayHandler(false);
                  resetItemQuantity();
                  setIsAddingItemToCard(false);
                }}
                disabled={!canCheckout}
              >
                {strings.SUBMIT_LABEL}
              </button>
            ) : <p>Adding item to cart...</p>}

        </div>
      </div>
    </div>
  );
}
